export interface CartItem {
  id: string;
  productId: string;
  name: string;
  price: number;
  image: string;
  quantity: number;
  category: string;
}

export const initialCartItems: CartItem[] = [
  {
    id: "ci1",
    productId: "1",
    name: "NOVA 스마트 도어락 Pro",
    price: 289000,
    image: "https://public.readdy.ai/ai/img_res/eb7d4091eb5fba88b7e9ac5722c4d3e5.jpg",
    quantity: 1,
    category: "도어락"
  },
  {
    id: "ci2",
    productId: "10",
    name: "NFC 카드키 세트 (10장)",
    price: 25000,
    image: "https://readdy.ai/api/search-image?query=NFC%20smart%20card%20key%20set%20on%20white%20background%2C%20minimalist%20design%2C%20thin%20plastic%20cards%2C%20home%20security%20access%20cards%2C%20clean%20product%20photography%2C%20studio%20lighting%2C%20modern%20style&width=600&height=700&seq=dl10&orientation=portrait",
    quantity: 2,
    category: "액세서리"
  }
];
